package com.techspiration.core.contract

import kotlinx.serialization.json.Json

/**
 * App + server ortak Json yapılandırması.
 *
 * `documents` JSONB sütununun (de)serileştirmesinde (server, Exposed `jsonb`) kullanılır.
 * `ignoreUnknownKeys = true` → ileri/geri uyum (DTO'ya alan eklenince eski kayıtlar okunabilir).
 */
val contractJson: Json = Json {
    ignoreUnknownKeys = true
}
